import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  userInfo: {},
  topLeftMenuIndex: '1',
  topRightMenuIndex: '0',
  sideMenuIndex: '1',
  product: {}
}

// 解决IE等低版本浏览器刷新导致数据清空的问题
for (let i in state) {
  // 遍历对象获取存值
  if (localStorage.getItem(i)) {
    state[i] = JSON.parse(localStorage.getItem(i))
  }
}

export default new Vuex.Store({
  state,
  mutations: {
    // mutations 类似methods
    // 写方法对数据做出更改(同步操作)
    setTopLeftMenuIndex (state, index) {
      state.topLeftMenuIndex = index
      localStorage.setItem('topLeftMenuIndex', JSON.stringify(state.topLeftMenuIndex))
    },
    setTopRightMenuIndex (state, index) {
      state.topRightMenuIndex = index
      localStorage.setItem('topRightMenuIndex', JSON.stringify(state.topRightMenuIndex))
    },
    setSideMenuIndex (state, index) {
      state.sideMenuIndex = index
      localStorage.setItem('sideMenuIndex', JSON.stringify(state.sideMenuIndex))
    },
    setProduct (state, product) {
      state.product = product
      localStorage.setItem('product', JSON.stringify(state.product))
    },
    setProductSample (state, product) {
      state.product.productName = product.productName
      state.product.productTip = product.productTip
      localStorage.setItem('product', JSON.stringify(state.product))
    },
    setUserInfo (state, user) {
      state.userInfo = user
      localStorage.setItem('userEmail', JSON.stringify(state.userEmail))
    }
  }
})
